export default __webpack_public_path__ + "static/menu-nikugatou-min2-33813be4020211b9f8bc0221652f446d.jpg";